import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { logoutUser } from "../../store/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

import withRouter from "../../components/common/withRouter";
import { AppDispatch, RootState } from "store";

const Logout = (props: any) => {
  const dispatch = useDispatch<AppDispatch>();

  const { isUserLogout } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(logoutUser());
  }, [dispatch]);

  if (isUserLogout) {
    return <Navigate to="/login" />;
  }

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);
